import { render, staticRenderFns } from "./u-tooltip-opacity-tile-lg.vue?vue&type=template&id=0fc0f496&scoped=true&"
import script from "./u-tooltip-opacity-tile-lg.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-opacity-tile-lg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0f496",
  null
  
)

export default component.exports